
import './App.css';

import React, { useState, useEffect } from 'react';
// import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import HeroSection from './componets/HeroSlider';
import Header from './componets/Header';
import Footer from './componets/Footer';
import AboutUss from './pages/AboutUss';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PageServices from './pages/services';
import ContactUs from './pages/ContactUs';
import PhotoGallery from './pages/PhotoGallery';
import Carrentalserviceinpune from './pages/car rental services in pune';
import Packages from './pages/Packages';
import ScrollToTop from './componets/ScrollToTop';
import Bestcabserviceinpune from './pages/Best Cab Services in Pune';
import Bestcabserviceinkochi from './pages/Best Cab Services in Kochi';
import Cabbookingfrommumbaitopune from './pages/Cab booking from Mumbai to Pune';
import Cabfrompunetomahabaleshwar from './pages/Cab from Pune to Mahabaleshwar';
import Monthlycabhirecontractinhyderbad from './pages/Monthly Cab hire contract in Hyderabad';
import Taxiservicefrompunetoshirdi from './pages/Taxi Services from Pune to Shirdi';
import Punetoshirdicab from './pages/Pune to Shirdi Cab';
import Mumbaitopunecorporatecab from './pages/Mumbai to Pune Corporate Cab';
import Outstationcabservicefrompune from './pages/Outstation Cab Services from Pune';
import Innovacrystarentalinpune from './pages/Innova Crysta rental in Pune';
import Corporatecabhireinpune from './pages/Corporate Cab hire in Pune';
import Punetoshirdicorporate from './pages/Pune to Shirdi Corporate Cab booking';
import Punetomumbaicorporatecabservice from './pages/Pune to Mumbai Corporate Cab Services';
import Monthlycorporatecabrentalinchennai from './pages/Monthly Corporate Cab rental in Chennai';
import Weddingcorporatecabbookinginpune from './pages/Wedding Corporate Cab bookings in Pune';
import Corporatecabserviceinkhradi from './pages/Corporate Cab Services in Kharadi';
import Corporatecabserviceinranchi from './pages/Corporate Cab Services in Ranchi';
import Corporatecabservinvadodara from './pages/Corporate Cab Services in Vadodara';
import Taxibookinginracnchi from './pages/Taxi booking in Ranchi';
import Corporatecabserviceinindia from './pages/Corporate Cab Services in India';
import Taxiserviceinvadodara from './pages/Taxi Services in Vadodara';
import Taxibookinginvadodara from './pages/Taxi booking in Vadodara';
import Bestcabserviceinhyderabad from './pages/Best Cab Services in Hyderabad';
import Cabserviceinamritsar from './pages/Cab Services in Amritsar';
import Cabbookinginamritsar from './pages/Cab booking in Amritsar';
import Citycabserviceinamritsar from './pages/City Cab Services in Amritsar';
import Corporatecabserviceinjalndhar from './pages/Corporate Cab Services in Jalandhar';
import Amritsartaxibooking from './pages/Amritsar Taxi booking';
import Corporatecabserviceinamritsar from './pages/Corporate Cab Services in Amritsar';
import Corporatecabserviecbooinginludhiana from './pages/Corporate Cab booking in Ludhiana';
import Corporatecabserviceingujrat from './pages/Corporate Cab Services in Gujarat';
import Leadingcabcompaniesinindia from './pages/Leading Cab Companies in India';
import Carrentalswithdriversinmumbai from './pages/Car Rentals with Drivers in Mumbai';
import Outstationcbservicefrommumbai from './pages/Outstation Cab Services from Mumbai';
import Monthlyvihiclerentalswithdriverinbanglore from './pages/Monthly Vehicle Rentals with Drivers in Bangalore';
import Luxurysedanrentals from './pages/Luxury Sedan Rentals with Drivers in Pune';
import Monthlycaranddriverrental from './pages/Monthly Car and Driver Rentals in Mumbai';
import Luxurycabserviceindelhi from './pages/Luxury Cab Services in Delhi';
import Trustedcorporatecabserviceinchennai from './pages/Trusted Corporate Cab Services in Chennai';
import Affordablecorporatecabserviceindelhi from './pages/Affordable Corporate Cab Services in Delhi';
import Budgetcorporatecabservice from './pages/Budget Corporate Cab Services in Kolkata';
import Leadingcabserviceacrossindia from './pages/Leading Cab Services across India';
import Luxurycabrentalsinindia from './pages/Luxury Cab Rentals in India';
import Monthlycorporatecabrental from './pages/Monthly Corporate Cab Rentals in Pune';
import Monthlycorporatecabhireinpune from './pages/Monthly Corporate Cab Hire in Pune';
import Airportcabserviceinmumbai from './pages/Airport Cab Services in Mumbai';
import Luxurycabbookinginpune from './pages/Luxury Cab Bookings in Pune';
import Premiumcorporatecabbookinginhyderabad from './pages/Premium Corporate Cab Bookings in Hyderabad';
import Innovaoustationcabrentalsfrompune from './pages/Innova Outstation Cab Rentals from Pune';
import Monthlycorporatecabplanindelhi from './pages/Monthly Corporate Cab Plans in Delhi';
import Onemonthcorporatecabrentalsinkolkata from './pages/One Month Corporate Cab Rentals in Kolkata';
import Onemonthrentalcorporatecabservice from './pages/One Month Rental Corporate Cab Services in Chennai';
import Buisnesstavelscabserviceindelhi from './pages/Business Travel Cab Services in Delhi';
import Chauffeurdrivenpremium from './pages/Chauffeur-Driven Premium Cabs in Bangalore';
import Premiumcabrentalwithdriveninbanglore from './pages/Premium Cab Rentals with Drivers in Bangalore';
import Mercedsrenlswithdriverindelhi from './pages/Mercedes Rentals with Drivers in Delhi';
import Mercedesbenzcabrentalsinmumbai from './pages/Mercedes Benz Cab Rentals in Mumbai';
import Monthlycorporatecabrentalsinchennai from './pages/Monthly Corporate Cab Rentals in Chennai';
import Luxurycabrentalswithdriverinpune from './pages/Luxury Cab Rentals with Drivers in Pune';
import Monthlycorporatecabrentalinhyderabad from './pages/Monthly Corporate Cab Rentals in Hyderabad';
import Longtermcorporatecabservice from './pages/Long-Term Corporate Cab Rentals in Delhi';
import Sixmonthcorporatecabrentalsinmumbai from './pages/Six-Month Corporate Cab Rentals in Mumbai';
import Corporatecabbookinginkolkata from './pages/Corporate Cab Bookings in Kolkata';
import Monthlycorporatecabrentalwithdriver from './pages/Monthly Corporate Cab Rentals with Drivers in Kolkata';
import Monthlycorporatecabbooking from './pages/Monthly Corporate Cab Bookings in Chennai';
import Corporatecabbookingserviceinmumbai from './pages/Corporate Cab Booking Services in Mumbai';
import Luxurycarentalsinpune from './pages/Luxury Cab Rentals in Pune';
import Bmwcabrentalsnearmeinmumbai from './pages/BMW Cab Rentals Near Me in Mumbai';
import Corporatecabbookinginhyderabad from './pages/Corporate Cab Bookings in Hyderabad';
import Onemonthcorporatecabrentalsinbanglore from './pages/One-Month Corporate Cab Rentals in Bangalore';
import Bmwrentalswithdrivelindelhi from './pages/BMW Rentals with Drivers in Delhi';
import Yearlycorporatecabrentalsinmumbai from './pages/Yearly Corporate Cab Rentals in Mumbai';
import Weddingcabbookinginpune from './pages/Wedding Cab Bookings in Pune';
import Mercedescabrentalsinbanglore from './pages/Mercedes Cab Rentals in Bangalore';
import Monthlycorporatecabbookinginmumbai from './pages/Monthly Corporate Cab Bookings in Mumbai';
import Chauffeurdrivenmercedence from './pages/Chauffeur-Driven Mercedes Rentals in Mumbai';
import Mercedesbenztaxiserviceinhyderabad from './pages/Mercedes Benz Taxi Services in Hyderabad';
import Vipcabserviceinchennai from './pages/VIP Cab Services in Chennai';
import Luxurytaxirentalinpune from './pages/Luxury Taxi Rentals in Pune';
import Sportscabbookinginbanglore from './pages/Sports Cab Bookings in Bangalore';
import Outstationcabbookinginpune from './pages/Outstation Cab Bookings in Pune';
import Luxurycabrentalsinmumbai from './pages/Luxury Cab Rentals in Mumbai';
import Weddingluxurycabrentalsindelhi from './pages/Wedding Luxury Cab Rentals in Delhi';
import Exoticcabbookinginkolkata from './pages/Exotic Cab Bookings in Kolkata';
import Mercedesbenzrentalswithdriver from './pages/Mercedes Benz Rentals with Drivers in Chennai';
import Weddingluxurycabrentals from './pages/Wedding Luxury Cab Rentals in Bangalore';
import Luxurycarrentalswithdriversinhyderabad from './pages/Luxury Car Rentals with Drivers in Hyderabad';
import Luxuryvanrentalswithdriverinmumbai from './pages/Luxury Van Rentals with Drivers in Mumbai';
import Cabhireserviceinpune from './pages/Cab Hire Services in Pune';
import Mercedeschauffeurserviceinbanglore from './pages/Mercedes Chauffeur Services in Bangalore';
import Premiumcabrentalinpune from './pages/Premium Cab Rentals in Pune';
import Luxurycabhireforweddingindelhi from './pages/Luxury Cab Hire for Weddings in Delhi';
import Ourfleets from './pages/Ourfleets';
import ContactButtons from './componets/ContactButtons';
import Booking from './pages/Booking';
import Enquiry from './pages/Enquiry';
import Gallery from './pages/Gallery';
import PageDrivers from './pages/TeamCard';
import Ourstaff from './pages/Ourstaff';
import Luxury from './componets/Vehicles/Luxury';
import Buses from './componets/Vehicles/Buses';
import VehicleFullCard from './componets/Vehicles/VehicleFullCard';
import Muv from './componets/Vehicles/Muv';
import Premium from './componets/Vehicles/premium';
import Sedan from './componets/Vehicles/Sedan';
import NetworkMap from './componets/NetworkMap';
import Evehical from './componets/Vehicles/E-Vehical';
import AaryanBookCar from './pages/AaryanBookCar';
import BlogSection from './pages/Blog';

// import Sedan from './components/Vehicles/Sedan';
// import Muv from './components/Vehicles/Muv';
// import VehicleDetails from './components/Vehicles/VehicleDetails';
// import Buses from './components/Vehicles/Buses';
// import Luxury from './components/Vehicles/Luxury';
// import Premium from './components/Vehicles/premium';
// import Career from './pages/Career';

function App() {
  return (
    <Router>
      <Header />
      <ContactButtons />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about" element={<AboutUss />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<PageServices />} />
        <Route path="/our-network" element={<NetworkMap />} />
        <Route path="/book-car" element={<AaryanBookCar />} />

        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blogs" element={<BlogSection />} />
        <Route path="/drivers" element={<PageDrivers />} />
        <Route path="/Office-staff" element={<Ourstaff />} />
        <Route path="/our-fleet" element={<Ourfleets />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/corporate-cab-services-in-pune" element={<Carrentalserviceinpune />} />
        <Route path="/best-cab-services-in-pune" element={<Bestcabserviceinpune />} />







<Route path="/sedan" element={<Sedan />} />
<Route path="/E-Vehical" element={<Evehical />} />
<Route path="/muv" element={<Muv />} />
<Route path="/premium" element={<Premium />} />
<Route path="/luxury" element={<Luxury />} />
<Route path="/buses" element={<Buses />} />
<Route path="/vehicle/:id" element={<VehicleFullCard />} />













     
<Route path="/best-cab-services-in-kochi" element={<Bestcabserviceinkochi />} />
<Route path="/cab-booking-from-mumbai-to-pune" element={<Cabbookingfrommumbaitopune />} />
<Route path="/cab-from-pune-to-mahabaleshwar" element={<Cabfrompunetomahabaleshwar />} />
<Route path="/monthly-cab-hire-contract-in-hyderabad" element={<Monthlycabhirecontractinhyderbad />} />
<Route path="/taxi-services-from-pune-to-shirdi" element={<Taxiservicefrompunetoshirdi />} />
<Route path="/pune-to-shirdi-cab" element={<Punetoshirdicab />} />
<Route path="/mumbai-to-pune-corporate-cab" element={<Mumbaitopunecorporatecab />} />
<Route path="/outstation-cab-services-from-pune" element={<Outstationcabservicefrompune />} />
<Route path="/innova-crysta-rental-in-pune" element={<Innovacrystarentalinpune />} />
<Route path="/corporate-cab-hire-in-pune" element={<Corporatecabhireinpune />} />
<Route path="/pune-to-shirdi-corporate-cab-booking" element={<Punetoshirdicorporate />} />
<Route path="/pune-to-mumbai-corporate-cab-services" element={<Punetomumbaicorporatecabservice />} />
<Route path="/monthly-corporate-cab-rental-in-chennai" element={<Monthlycorporatecabrentalinchennai />} />
<Route path="/wedding-cab-bookings-in-pune" element={<Weddingcorporatecabbookinginpune />} />
<Route path="/corporate-cab-services-in-kharadi-pune" element={<Corporatecabserviceinkhradi />} />
<Route path="/corporate-cab-services-in-ranchi" element={<Corporatecabserviceinranchi />} />
<Route path="/corporate-cab-services-in-vadodara" element={<Corporatecabservinvadodara />} />
<Route path="/taxi-booking-in-ranchi" element={<Taxibookinginracnchi />} />
<Route path="/corporate-cab-services-in-india" element={<Corporatecabserviceinindia />} />
<Route path="/taxi-services-in-vadodara-gujarat" element={<Taxiserviceinvadodara />} />
<Route path="/taxi-booking-in-vadodara" element={<Taxibookinginvadodara />} />
<Route path="/best-cab-services-in-hyderabad" element={<Bestcabserviceinhyderabad />} />
<Route path="/cab-services-in-amritsar" element={<Cabserviceinamritsar />} />
<Route path="/cab-booking-in-amritsar" element={<Cabbookinginamritsar />} />
<Route path="/city-cab-services-in-amritsar" element={<Citycabserviceinamritsar />} />
<Route path="/corporate-cab-services-in-jalandhar" element={<Corporatecabserviceinjalndhar />} />
<Route path="/amritsar-taxi-booking" element={<Amritsartaxibooking />} />
<Route path="/corporate-cab-services-in-amritsar" element={<Corporatecabserviceinamritsar />} />
<Route path="/corporate-cab-booking-in-ludhiana" element={<Corporatecabserviecbooinginludhiana />} />
<Route path="/corporate-cab-services-in-gujarat" element={<Corporatecabserviceingujrat />} />
<Route path="/leading-cab-companies-in-india" element={<Leadingcabcompaniesinindia />} />
<Route path="/car-rentals-with-drivers-in-mumbai" element={<Carrentalswithdriversinmumbai />} />
<Route path="/outstation-cab-services-from-mumbai" element={<Outstationcbservicefrommumbai />} />


<Route path="/monthly-vehicle-rentals-with-drivers-in-bangalore" element={<Monthlyvihiclerentalswithdriverinbanglore />} />
<Route path="/luxury-sedan-rentals-with-drivers-in-pune" element={<Luxurysedanrentals />} />
<Route path="/monthly-car-and-driver-rentals-in-mumbai" element={<Monthlycaranddriverrental />} />
<Route path="/luxury-cab-services-in-delhi" element={<Luxurycabserviceindelhi />} />
<Route path="/trusted-corporate-cab-services-in-chennai" element={<Trustedcorporatecabserviceinchennai />} />
<Route path="/affordable-corporate-cab-services-in-delhi" element={<Affordablecorporatecabserviceindelhi />} />
<Route path="/budget-corporate-cab-services-in-kolkata" element={<Budgetcorporatecabservice />} />
<Route path="/leading-cab-services-across-india" element={<Leadingcabserviceacrossindia />} />
<Route path="/luxury-cab-rentals-in-india" element={<Luxurycabrentalsinindia />} />
<Route path="/monthly-corporate-cab-rentals-in-pune" element={<Monthlycorporatecabrental />} />
<Route path="/monthly-corporate-cab-hire-in-pune" element={<Monthlycorporatecabhireinpune />} />
<Route path="/airport-cab-services-in-mumbai" element={<Airportcabserviceinmumbai />} />
<Route path="/luxury-cab-bookings-in-pune" element={<Luxurycabbookinginpune />} />
<Route path="/premium-corporate-cab-bookings-in-hyderabad" element={<Premiumcorporatecabbookinginhyderabad />} />
<Route path="/innova-outstation-cab-rentals-from-pune" element={<Innovaoustationcabrentalsfrompune />} />
<Route path="/monthly-corporate-cab-plans-in-delhi" element={<Monthlycorporatecabplanindelhi />} />
<Route path="/one-month-corporate-cab-rentals-in-kolkata" element={<Onemonthcorporatecabrentalsinkolkata />} />
<Route path="/one-month-rental-corporate-cab-services-in-chennai" element={<Onemonthrentalcorporatecabservice />} />
<Route path="/business-travel-cab-services-in-delhi" element={<Buisnesstavelscabserviceindelhi />} />
<Route path="/chauffeur-driven-premium-cabs-in-bangalore" element={<Chauffeurdrivenpremium />} />
<Route path="/premium-cab-rentals-with-drivers-in-bangalore" element={<Premiumcabrentalwithdriveninbanglore />} />
<Route path="/mercedes-rentals-with-drivers-in-delhi" element={<Mercedsrenlswithdriverindelhi />} />
<Route path="/mercedes-benz-cab-rentals-in-mumbai" element={<Mercedesbenzcabrentalsinmumbai />} />
<Route path="/monthly-corporate-cab-rentals-in-chennai" element={<Monthlycorporatecabrentalsinchennai />} />
<Route path="/luxury-cab-rentals-with-drivers-in-pune" element={<Luxurycabrentalswithdriverinpune />} />
<Route path="/monthly-corporate-cab-rentals-in-hyderabad" element={<Monthlycorporatecabrentalinhyderabad />} />
<Route path="/long-term-corporate-cab-rentals-in-delhi" element={<Longtermcorporatecabservice />} />


<Route path="/six-month-corporate-cab-rentals-in-mumbai" element={<Sixmonthcorporatecabrentalsinmumbai />} />
<Route path="/corporate-cab-bookings-in-kolkata" element={<Corporatecabbookinginkolkata />} />
<Route path="/monthly-corporate-cab-rentals-with-drivers-in-kolkata" element={<Monthlycorporatecabrentalwithdriver />} />
<Route path="/monthly-corporate-cab-bookings-in-chennai" element={<Monthlycorporatecabbooking />} />
<Route path="/corporate-cab-booking-services-in-mumbai" element={<Corporatecabbookingserviceinmumbai />} />
<Route path="/luxury-cab-rentals-in-pune" element={<Luxurycarentalsinpune />} />
<Route path="/bmw-cab-rentals-near-me-in-mumbai" element={<Bmwcabrentalsnearmeinmumbai />} />
<Route path="/corporate-cab-bookings-in-hyderabad" element={<Corporatecabbookinginhyderabad />} />
<Route path="/one-month-corporate-cab-rentals-in-bangalore" element={<Onemonthcorporatecabrentalsinbanglore />} />
<Route path="/bmw-rentals-with-drivers-in-delhi" element={<Bmwrentalswithdrivelindelhi />} />
<Route path="/yearly-corporate-cab-rentals-in-mumbai" element={<Yearlycorporatecabrentalsinmumbai />} />
<Route path="/wedding-cab-bookings-in-pune" element={<Weddingcabbookinginpune />} />
<Route path="/mercedes-cab-rentals-in-bangalore" element={<Mercedescabrentalsinbanglore />} />
<Route path="/monthly-corporate-cab-bookings-in-mumbai" element={<Monthlycorporatecabbookinginmumbai />} />
<Route path="/chauffeur-driven-mercedes-rentals-in-mumbai" element={<Chauffeurdrivenmercedence />} />
<Route path="/mercedes-benz-taxi-services-in-hyderabad" element={<Mercedesbenztaxiserviceinhyderabad />} />
<Route path="/vip-cab-services-in-chennai" element={<Vipcabserviceinchennai />} />
<Route path="/luxury-taxi-rentals-in-pune" element={<Luxurytaxirentalinpune />} />
<Route path="/sports-cab-bookings-in-bangalore" element={<Sportscabbookinginbanglore />} />
<Route path="/outstation-cab-bookings-in-pune" element={<Outstationcabbookinginpune />} />
<Route path="/luxury-cab-rentals-in-mumbai" element={<Luxurycabrentalsinmumbai />} />
<Route path="/wedding-luxury-cab-rentals-in-delhi" element={<Weddingluxurycabrentalsindelhi />} />
<Route path="/exotic-cab-bookings-in-kolkata" element={<Exoticcabbookinginkolkata />} />
<Route path="/mercedes-benz-rentals-with-drivers-in-chennai" element={<Mercedesbenzrentalswithdriver />} />
<Route path="/wedding-luxury-cab-rentals-in-bangalore" element={<Weddingluxurycabrentals />} />
<Route path="/luxury-car-rentals-with-drivers-in-hyderabad" element={<Luxurycarrentalswithdriversinhyderabad />} />
<Route path="/luxury-van-rentals-with-drivers-in-mumbai" element={<Luxuryvanrentalswithdriverinmumbai />} />
<Route path="/cab-hire-services-in-pune" element={<Cabhireserviceinpune />} />
<Route path="/mercedes-chauffeur-services-in-bangalore" element={<Mercedeschauffeurserviceinbanglore />} />
<Route path="/premium-cab-rentals-in-pune" element={<Premiumcabrentalinpune />} />
<Route path="/luxury-cab-hire-for-weddings-in-delhi" element={<Luxurycabhireforweddingindelhi />} />

      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
